import DapDSSkeleton from './skeleton.component'

export * from './skeleton.component'
export default DapDSSkeleton

DapDSSkeleton.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-skeleton': DapDSSkeleton
  }
}
